import { ArrowLeft } from "lucide-react";
import { BRAND_LOGO } from "@/lib/brandAssets";

export default function OnboardingShell({ children, step, totalSteps, label, onBack }) {
  return (
    <div className="min-h-screen bg-sidebar flex flex-col">
      {/* Logo */}
      <div className="flex justify-center pt-8 pb-4">
        <img
          src={BRAND_LOGO}
          alt="TA Fitness Logo"
          className="h-16 object-contain"
        />
      </div>

      {/* Step dots + label */}
      {totalSteps > 1 && (
        <div className="flex flex-col items-center gap-2 mb-6 px-4">
          <div className="flex gap-2">
            {Array.from({ length: totalSteps }).map((_, i) => (
              <div
                key={i}
                className={`h-2 rounded-full transition-all ${
                  i < step - 1
                    ? "w-2 bg-primary"
                    : i === step - 1
                    ? "w-6 bg-primary"
                    : "w-2 bg-sidebar-border"
                }`}
              />
            ))}
          </div>
          {label && (
            <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">
              {label}
            </p>
          )}
        </div>
      )}

      {/* Card */}
      <div className="flex-1 flex items-start justify-center px-4 pb-12">
        <div className="w-full max-w-md bg-card rounded-2xl shadow-2xl p-6 sm:p-8 relative">
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              data-testid="onboarding-back"
              className="absolute top-4 left-4 inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-muted/60 transition-colors"
              aria-label="Back"
            >
              <ArrowLeft className="w-4 h-4 text-muted-foreground" />
            </button>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
